<template>
  <div>
    <el-row class="hidden-xs-only">
      <el-col :span="24">
        <el-carousel height="722px" autoplay arrow="never">
          <el-carousel-item
            v-for="(item, index) in info.banner_list"
            :key="index"
          >
            <img :src="item.image" class="width-100 h-722" />
          </el-carousel-item>
          <div class="fu">
            <div class="d-flex-center c-white f-60">
              {{ info.base_info.banner_title }}
            </div>
            <div class="m-t-200 d-flex-center">
              <div class="h-75 width-50 d-flex-row" @click="go">
                <div class="bgc-white">
                  <el-dropdown>
                    <span class="el-dropdown-link lh-75 p-l-15 f-16 c-33">
                      长春<i
                        class="el-icon-caret-bottom el-icon--right c-D8D8D8"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <!-- <el-dropdown-item>哈尔滨</el-dropdown-item>
											<el-dropdown-item>长春</el-dropdown-item> -->
                      <!-- <el-dropdown-item>长春</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="width-75 bgc-white lh-75 p-l-20">
                  <input
                    v-model="search"
                    placeholder="填写区域门店"
                    class="width-100"
                  />
                </div>
                <div
                  class="w-170 h-75 lh-75 bgc-E94638 c-white d-flex-items-center d-flex-center"
                >
                  <img
                    src="@/assets/image/index/search.png"
                    class="w-21 h-21"
                  />
                  <span class="f-14 m-l-12">搜索</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel>
      </el-col>
    </el-row>
    <el-row class="hidden-sm-and-up">
      <el-col :span="24">
        <el-carousel height="315px" autoplay arrow="never">
          <el-carousel-item
            v-for="(item, index) in info.banner_list"
            :key="index"
          >
            <img :src="item.image" class="width-100 h-315" />
          </el-carousel-item>
          <div class="fu1">
            <div class="d-flex-center c-white f-40" style="text-align: center">
              {{ info.base_info.banner_title }}
            </div>
            <div class="m-t-30 d-flex-center">
              <div class="h-40 width-80 d-flex-row">
                <div class="bgc-white w-120">
                  <el-dropdown>
                    <span class="el-dropdown-link lh-40 p-l-15 f-16 c-33">
                      长春<i
                        class="el-icon-caret-bottom el-icon--right c-D8D8D8"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <!-- 	<el-dropdown-item>哈尔滨</el-dropdown-item>
											<el-dropdown-item>长春</el-dropdown-item> -->
                      <el-dropdown-item>长春</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div
                  class="width-75 bgc-white lh-40 p-l-20"
                  style="background-color: red"
                >
                  <input
                    v-model="search"
                    placeholder="填写区域门店"
                    class="width-100"
                  />
                </div>
                <div
                  class="w-120 h-40 lh-40 bgc-E94638 c-white d-flex-items-center d-flex-center"
                >
                  <img
                    src="@/assets/image/index/search.png"
                    class="w-15 h-15"
                  />
                  <span class="f-14 m-l-12">搜索</span>
                </div>
              </div>
            </div>
          </div>
        </el-carousel>
      </el-col>
    </el-row>
    <el-row class="bgc-f4f4f4">
      <el-col :span="24">
        <title-box
          :topshow="false"
          titletop=""
          title="推荐房源"
          styletop=""
          stylebot="d-flex-center f-34 c-00 font-weight-bold"
          all="m-t-50 m-b-40"
        >
        </title-box>

        <div class="d-flex-center hidden-xs-only">
          <div
            class="width-80 d-flex-center wow bounceInRight"
            data-wow-duration="2s"
            data-wow-delay="0s"
            data-wow-offset="10"
            data-wow-iteration="1"
          >
            <div
              @click="gogo(item.community_id)"
              v-for="(item, index) in info.recommend_hourse_list"
              :key="index"
              :class="index != 2 ? 'm-r-40' : ''"
              class="b-all-C9C6C6 width-33"
            >
              <img :src="item.image" class="width-100 h-220 b-b" />
              <div
                class="f-14 c-white bgc-E94638 w-100 h-30 d-flex-items-center d-flex-center"
                style="margin-top: -220px; position: absolute; z-index: 2"
              >
                {{ item.typelist }}
              </div>
              <div class="bgc-white p-t-10 p-l-25 p-r-25">
                <div class="f-20 c-33 font-weight-bold">
                  {{ item.hr_name }}{{ item.address }}
                </div>
                <div class="f-16 c-66 m-t-10">
                  <span>{{ item.administrative_regionlist }}</span>
                  <span class="m-r-10 m-l-10">|</span>
                  <span>{{ item.measure_area }}㎡</span>
                </div>
                <div class="f-20 c-EC4738 m-t-20 p-b-30">
                  ￥{{ item.now_price }}/月
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 	<div class="d-flex-center hidden-sm-and-up" style="overflow-x: scroll;overflow: hidden;">
					<div class="width-90 d-flex-row" style="overflow: auto;">
						<div v-for="(item,index) in store" :key="index" :class="index !=2? 'm-r-20':''"
							class="b-all-C9C6C6 w-250 br-20">
							<img :src="item.img" class="w-250 h-120 br-rt br-lt" />
							<div class="br-lt f-14 c-white bgc-E94638 w-100 h-30 d-flex-items-center d-flex-center"
								style="margin-top: -120px;position: relative;">
								{{item.toptitle}}
							</div>
							<div class="bgc-white p-t-20 p-l-25 p-r-25 m-t-90 br-rb br-lb">
								<div class="f-18 c-33 font-weight-bold">{{item.title}}</div>
								<div class="f-14 c-66 m-t-10">
									<span>{{item.addres}}</span>
									<span class="m-r-10 m-l-10">|</span>
									<span>{{item.size}}</span>
								</div>
								<div class="f-18 c-EC4738 m-t-10 p-b-30">￥{{item.price}}/月</div>
							</div>
						</div>
					</div>
				</div> -->

        <div @click="liston($event)" class="d-flex-center hidden-sm-and-up">
          <vue-seamless-scroll
            :data="info.recommend_hourse_list"
            :class-option="classOption1"
            class="warp h-300"
          >
            <ul class="ul-item">
              <li
                @click="gogo(item.community_id)"
                :data-id="index"
                v-for="(item, index) in info.recommend_hourse_list"
                :key="index"
                class="b-all-C9C6C6 w-250 br-20 li-item m-r-10 m-l-10"
              >
                <img :src="item.image" class="w-250 h-120 br-rt br-lt" />
                <div
                  class="br-lt f-14 c-white bgc-E94638 w-100 h-30 d-flex-items-center d-flex-center"
                  style="margin-top: -120px; position: relative"
                >
                  {{ item.typelist }}
                </div>
                <div class="bgc-white p-t-20 p-l-25 p-r-25 m-t-90 br-rb br-lb">
                  <div class="f-18 c-33 font-weight-bold">
                    {{ item.hr_name }}{{ item.address }}
                  </div>
                  <div class="f-14 c-66 m-t-10">
                    <span>{{ item.administrative_regionlist }}</span>
                    <span class="m-r-10 m-l-10">|</span>
                    <span>{{ item.measure_area }}㎡</span>
                  </div>
                  <div class="f-18 c-EC4738 m-t-10 p-b-30">
                    ￥{{ item.now_price }}/月
                  </div>
                </div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>

        <title-box
          :topshow="false"
          titletop=""
          title="精选房源"
          styletop=""
          stylebot="d-flex-center f-34 c-00 font-weight-bold"
          all="m-t-50 m-b-40"
        >
        </title-box>

        <div class="d-flex-center hidden-xs-only">
          <div
            class="width-80 m-l-20 m-r-20 d-flex-between d-flex-items-center"
          >
            <div class="d-flex-between width-40">
              <div
                @mouseover="mouseover(index)"
                @click="select(item.house_id)"
                v-for="(item, index) in selected"
                :key="index"
              >
                <div
                  :class="nav == index ? 'c-33' : 'c-99'"
                  class="d-flex-items-center f-18"
                >
                  {{ item }}
                </div>
                <div :class="nav == index ? 'bgc-EC4738 h-4 m-t-10' : ''"></div>
              </div>
            </div>
            <div class="f-18 c-33 font-weight-bold">
              查看更多<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>

        <div class="d-flex-center hidden-sm-and-up">
          <div
            class="width-80 m-l-20 m-r-20 d-flex-between d-flex-items-center"
          >
            <div class="d-flex-between width-100">
              <div
                @mouseover="mouseover(index)"
                v-for="(item, index) in selected"
                :key="index"
                @click="select(item.house_id)"
              >
                <div
                  :class="nav == index ? 'c-33 font-weight-bold' : 'c-99'"
                  class="d-flex-items-center f-18"
                >
                  {{ item }}
                </div>
                <div :class="nav == index ? 'bgc-EC4738 h-4 m-t-10' : ''"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden-xs-only">
          <div
            v-if="index == 0"
            v-for="(item, index) in info.selected_hourse_list"
            :key="index"
            class="d-flex-center"
          >
            <div class="m-t-50 width-80 m-l-20 m-r-20">
              <div class="d-flex-row">
                <div class="width-60 h-550">
                  <img :src="item.image" class="w-100p h-550" />
                  <div
                    class="bgc f-14 c-white w-100 h-30 d-flex-items-center d-flex-center"
                    style="margin-top: -550px; position: absolute; z-index: 9"
                  >
                    <img
                      src="@/assets/image/index/room.png"
                      class="w-22 h-20 m-r-5"
                    />
                    {{ item.typelist }}
                  </div>
                </div>
                <!-- 上面的 -->
                <div
                  class="width-40 bgc-white b-all h-550"
                  style="overflow: hidden"
                >
                  <div
                    class="f-34 c-33 font-weight-bold p-t-100 p-l-50 p-r-50 overtext"
                  >
                    {{ item.hr_name }}{{ item.address }}
                  </div>
                  <div class="f-20 c-66 m-t-30 p-l-50 p-r-50">
                    <span>{{ item.administrative_regionlist }}</span>
                    <span class="m-r-10 m-l-10">|</span>
                    <span>{{ item.measure_area }}㎡</span>
                  </div>
                  <div class="d-flex-row p-l-50 p-r-50 d-flex-wrap">
                    <img
                      src="@/assets/image/index/h-1.png"
                      class="w-66 h-30 m-r-10 m-t-20"
                    />
                    <img
                      src="@/assets/image/index/h-2.png"
                      class="w-66 h-30 m-r-14 m-t-20"
                    />
                    <img
                      src="@/assets/image/index/h-3.png"
                      class="w-109 h-32 m-t-20"
                    />
                  </div>
                  <div class="c-EC4738 m-t-30 p-l-50 p-r-50">
                    <span class="f-36 font-weight-bold"
                      >¥{{ item.now_price }}</span
                    >
                    <span class="f-24 font-weight-bold">/月</span>
                  </div>
                  <div class="bgimg m-t-40 p-l-50 p-r-50">
                    <div class="d-flex-between p-t-80 p-b-50">
                      <div class="f-34 c-99">查看详情</div>
                      <i class="el-icon-right f-34 c-99"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex-center">
            <div class="d-flex-between m-t-20 width-80 m-l-20 m-r-20">
              <div
                v-if="index != 0"
                v-for="(item, index) in info.selected_hourse_list"
                :key="index"
                :class="index == 2 ? 'm-l-20' : ''"
                class="width-50 h-283"
              >
                <img :src="item.image" class="w-100p h-283" />
                <div
                  class="bgc f-14 c-white w-100 h-30 d-flex-items-center d-flex-center"
                  style="position: absolute; z-index: 9; margin-top: -283px"
                >
                  <img
                    src="@/assets/image/index/room.png"
                    class="w-22 h-20 m-r-5"
                  />
                  {{ item.typelist }}
                </div>
                <div class="p-25" style="margin-top: -100px">
                  <div class="d-flex-between f-20 c-white">
                    <div>{{ item.hr_name }}{{ item.address }}</div>
                    <div>¥{{ item.now_price }}/月</div>
                  </div>
                  <div class="f-16 c-white m-t-10">
                    <span>{{ item.administrative_regionlist }}</span>
                    <span class="m-l-10 m-r-10">|</span>
                    <span>{{ item.measure_area }}㎡</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden-sm-and-up">
          <div
            v-if="index == 0"
            v-for="(item, index) in info.selected_hourse_list"
            :key="index"
            class="d-flex-center"
          >
            <div class="m-t-50 width-80 m-l-20 m-r-20">
              <div class="width-100 h-300 br-rt br-lt">
                <img :src="item.image" class="w-100p h-300 br-rt br-lt" />
                <div
                  class="bgc br-lt f-14 c-white w-100 h-30 d-flex-items-center d-flex-center"
                >
                  <img
                    src="@/assets/image/index/room.png"
                    class="w-22 h-20 m-r-5"
                  />
                  {{ item.typelist }}
                </div>
              </div>
              <div class="width-100 bgc-white b-all br-rb br-lb">
                <div class="f-20 c-33 font-weight-bold p-t-20 p-l-30 p-r-30">
                  {{ item.hr_name }}{{ item.address }}
                </div>
                <div class="f-14 c-66 m-t-10 p-l-30 p-r-30">
                  <span>{{ item.administrative_regionlist }}</span>
                  <span class="m-r-10 m-l-10">|</span>
                  <span>{{ item.measure_area }}㎡</span>
                </div>
                <div class="m-t-10 d-flex-row p-l-30 p-r-30">
                  <img
                    src="../../assets/image/index/h-1.png"
                    class="w-40 h-20 m-r-10"
                  />
                  <img
                    src="@/assets/image/index/h-2.png"
                    class="w-40 h-20 m-r-14"
                  />
                  <img src="@/assets/image/index/h-3.png" class="w-70 h-20" />
                </div>
                <div class="d-flex-between d-flex-items-center m-t-20 p-b-20">
                  <div class="c-EC4738 p-l-30">
                    <span class="f-24 font-weight-bold"
                      >¥{{ item.now_price }}</span
                    >
                    <span class="f-14 font-weight-bold">/月</span>
                  </div>
                  <div class="d-flex-row p-r-30">
                    <div class="f-18 c-99 m-r-10">查看详情</div>
                    <i class="el-icon-right f-18 c-99"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex-center">
            <div class="d-flex-between m-t-20 width-80 m-l-20 m-r-20">
              <div
                v-if="index != 0"
                v-for="(item, index) in info.selected_hourse_list"
                :key="index"
                :class="index == 2 ? 'm-l-20' : ''"
                class="width-50 h-230 br-20"
                :style="{ background: 'url(' + item.image + ')' }"
                style="
                  width: 50%;
                  height: 230px;
                  background-size: 100% 230px;
                  background-repeat: no-repeat;
                "
              >
                <div
                  class="bgc br-lt f-14 c-white w-100 h-30 d-flex-items-center d-flex-center"
                >
                  <img
                    src="@/assets/image/index/room.png"
                    class="w-22 h-20 m-r-5"
                  />
                  {{ item.typelist }}
                </div>
                <div class="m-t-50 p-15">
                  <div class="f-14 c-white">
                    {{ item.hr_name }}{{ item.address }}
                  </div>
                  <div class="f-12 c-white m-t-10">
                    <span>{{ item.administrative_regionlist }}</span>
                    <span class="m-l-10 m-r-10">|</span>
                    <span>{{ item.measure_area }}㎡</span>
                  </div>
                  <div class="f-20 c-white m-t-10">
                    ¥{{ item.now_price }}/月
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <title-box
          :topshow="true"
          titletop="Runyu dynamic news"
          title="润寓动态"
          styletop="d-flex-center f-24 c-99 m-b-10"
          stylebot="d-flex-center f-34 c-33 font-weight-bold"
          all="m-t-50 m-b-40"
        >
        </title-box>

        <div class="d-flex-center hidden-xs-only">
          <div class="d-flex-between width-80 bgc-white p-40">
            <div
              class="width-40 h-292"
              :style="{
                background: 'url(' + newinfo.news_list[0].smallimages + ')',
              }"
              style="background-size: 100% 100%; background-repeat: no-repeat"
            >
              <div class="bgc-000000">
                <div
                  class="w-110 h-110 m-l-40 bgc-DF4D40 d-flex-center d-flex-items-center"
                >
                  <div class="c-white d-flex-center">
                    <div class="f-20 width-60">
                      {{ newinfo.news_list[0].create_time }}
                    </div>
                    <!-- <div class="f-16 m-t-10">
											2022.
										</div> -->
                  </div>
                </div>
                <div
                  class="d-flex-center f-20 c-white p-t-120 p-b-34 width-100 overtext"
                >
                  {{ newinfo.news_list[0].title }}
                </div>
              </div>
            </div>
            <div class="width-60 m-l-40">
              <div class="b-b h-43 d-flex-between">
                <div class="f-20 c-33 font-weight-bold">园区新闻</div>
                <div class="f-16 c-33">更多</div>
              </div>
              <div @click="handleClick($event)">
                <vue-seamless-scroll
                  :data="newinfo.news_list"
                  class="seamless-warp m-t-20"
                  :class-option="defaultOption"
                >
                  <ul class="item">
                    <li
                      v-for="(item, index) in newinfo.news_list"
                      :key="index"
                      class="d-flex-between m-t-20 f-16 c-33 width-100p"
                    >
                      <div class="title d-flex-between width-100">
                        <span :data-id="item.news_id">{{ item.title }}</span>
                        <span :data-id="item.news_id">{{
                          item.create_time
                        }}</span>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex-center hidden-sm-and-up">
          <div class="width-80 bgc-white p-20">
            <div
              class="width-100 h-220"
              :style="{
                background: 'url(' + newinfo.news_list[0].smallimages + ')',
              }"
              style="background-size: 100% 100%"
            >
              <div class="bgc-000000">
                <div
                  class="w-80 h-80 m-l-40 bgc-DF4D40 d-flex-center d-flex-items-center"
                >
                  <div class="c-white d-flex-center">
                    <div class="f-20 width-80">
                      {{ newinfo.news_list[0].create_time }}
                    </div>
                    <!-- 	<div class="f-16 m-t-10">
											2022.
										</div> -->
                  </div>
                </div>
                <div class="d-flex-center f-14 c-white p-t-96 p-b-25">
                  {{ newinfo.news_list[0].title }}
                </div>
              </div>
            </div>
            <div class="width-100 m-t-40">
              <div class="b-b h-43 d-flex-between">
                <div class="f-20 c-33 font-weight-bold">园区新闻</div>
                <div class="f-16 c-33">更多</div>
              </div>
              <div @click="handleClick($event)">
                <vue-seamless-scroll
                  :data="newinfo.news_list"
                  class="seamless-warp m-t-20"
                  :class-option="defaultOption"
                >
                  <ul class="item">
                    <li
                      v-for="(item, index) in newinfo.news_list"
                      :key="index"
                      class="m-t-20 f-16 c-33 width-100p"
                    >
                      <div class="title d-flex-between width-100">
                        <span :data-id="index" class="width-60 overtext">{{
                          item.title
                        }}</span>
                        <span :data-id="index">{{ item.create_time }}</span>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex-center hidden-xs-only">
          <div class="d-flex-center m-t-20 width-80" style="overflow: hidden">
            <div
              v-for="(item, index) in listthress"
              :key="index"
              class="bgc-white h-220 width-33 p-20"
              :class="index != 2 ? 'm-r-20' : ''"
            >
              <div class="b-b p-b-25 d-flex-between p-t-10">
                <div class="f-20 c-00 font-weight-bold">{{ item.title }}</div>
                <div class="f-16 c-33">更多</div>
              </div>
              <div
                v-if="index == 0"
                class="m-t-20 h-97 p-b-10"
                style="overflow: hidden"
              >
                <div
                  v-for="(itemn, indexn) in newinfo.notice_list"
                  :key="indexn"
                  class="f-16 c-33 m-b-20"
                >
                  <div class="f-16 c-33 m-b-20">
                    {{ itemn.title }}
                  </div>
                </div>
              </div>
              <div
                v-if="index == 1"
                class="m-t-20 h-97 p-b-10"
                style="overflow: hidden"
              >
                <div
                  v-for="(itemi, indexi) in newinfo.instructions_list"
                  :key="indexi"
                  class="f-16 c-33 m-b-20"
                >
                  <div class="f-16 c-33 m-b-20">
                    {{ itemi.title }}
                  </div>
                </div>
              </div>
              <div
                v-if="index == 2"
                class="m-t-20 h-97 p-b-10"
                style="overflow: hidden"
              >
                <div
                  v-for="(itemq, indexq) in newinfo.question_list"
                  :key="indexq"
                  class="f-16 c-33 m-b-20"
                >
                  <div class="f-16 c-33 m-b-20">
                    {{ itemq.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex-center hidden-sm-and-up">
          <div class="m-t-20 width-80">
            <div
              v-for="(item, index) in listthress"
              :key="index"
              class="bgc-white m-b-20 h-210 width-100 p-20"
            >
              <div class="b-b p-b-25 d-flex-between p-t-10">
                <div class="f-20 c-00 font-weight-bold">{{ item.title }}</div>
                <div class="f-16 c-33">更多</div>
              </div>
              <div class="m-t-30 p-b-10">
                <div
                  v-if="index == 0"
                  v-for="(itemn, indexn) in newinfo.notice_list"
                  :key="indexn"
                  class="f-16 c-33 m-b-20"
                >
                  <div class="f-16 c-33 m-b-20 overtext">
                    {{ itemn.title }}
                  </div>
                </div>
                <div
                  v-if="index == 1"
                  v-for="(itemi, indexi) in newinfo.instructions_list"
                  :key="indexi"
                  class="f-16 c-33 m-b-20"
                >
                  <div class="f-16 c-33 m-b-20 overtext">
                    {{ itemi.title }}
                  </div>
                </div>
                <div
                  v-if="index == 2"
                  v-for="(itemq, indexq) in newinfo.question_list"
                  :key="indexq"
                  class="f-16 c-33 m-b-20"
                >
                  <div class="f-16 c-33 m-b-20 overtext">
                    {{ itemq.title }}
                  </div>
                </div>
                <!-- <div v-for="(iteml,indexl) in item.list" class="f-16 c-33 m-b-20">
									<div class="f-16 c-33 m-b-20 overtext">
										{{iteml.name}}
									</div>
									<div v-if="index==2" class="f-16 c-33 m-b-20 overtext">
										{{iteml.content}}
									</div>
								</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex-center m-b-50 hidden-xs-only">
          <div class="d-flex-row m-t-20 width-80">
            <div class="bgc-white width-66-20 m-r-20 p-20">
              <div class="f-20 c-00 font-weight-bold m-t-20">疾病预防</div>
              <div class="m-t-35 d-flex-between">
                <img
                  :src="newother.disease_list[2].smallimages"
                  class="width-50 m-r-20"
                />
                <img
                  :src="newother.disease_list[1].smallimages"
                  class="width-20 m-r-20"
                />
                <img
                  :src="newother.disease_list[0].smallimages"
                  class="width-20"
                />
              </div>
            </div>
            <div class="bgc-white width-33 p-20">
              <div class="f-20 c-00 font-weight-bold m-t-20">问卷调查</div>
              <div class="m-t-35">
                <img
                  src="../../assets/image/index/yuyue.png"
                  class="width-100"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex-center m-b-50 hidden-sm-and-up">
          <div class="width-80">
            <div class="bgc-white width-100 p-20">
              <div class="f-20 c-00 font-weight-bold m-t-20">疾病预防</div>
              <div class="m-t-35">
                <img
                  :src="newother.disease_list[2].smallimages"
                  class="width-100"
                />
                <div class="d-flex-between m-t-20">
                  <img
                    :src="newother.disease_list[1].smallimages"
                    class="width-45 m-r-20"
                  />
                  <img
                    :src="newother.disease_list[0].smallimages"
                    class="width-45"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row class="bgc-white">
      <el-col :span="24">
        <div class="d-flex-center hidden-xs-only">
          <div class="width-80 d-flex-between p-t-90 m-b-100">
            <div class="width-50">
              <title-box
                :topshow="true"
                titletop="Runyu Apartment Quality Service"
                title="长春市人才公寓概况"
                styletop="f-24 c-99 m-b-15"
                stylebot="f-36 c-00"
                all="m-t-50 m-b-40"
              >
              </title-box>
              <div
                class="f-20 c-00 width-70 lh-40 m-t-70"
                v-html="newother.about_main.maincontent"
              ></div>
              <div class="m-t-80">
                <div class="f-30 c-99">
                  更多概况
                  <i class="el-icon-right f-30 c-99"></i>
                </div>
              </div>
            </div>
            <div class="width-50 p-l-40 d-flex-end p-r-50">
              <video
                id="video"
                :src="newother.about_main.video_file"
                controls="true"
                poster="../../assets/image/index/vi.png"
                preload="auto"
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x5-video-orientation="portraint"
                style="object-fit: fill"
                class="width-90 h-500 shadow"
              ></video>
            </div>
          </div>
        </div>

        <div class="d-flex-center hidden-sm-and-up">
          <div class="m-l-20 m-r-20 m-b-100">
            <div class="width-100">
              <title-box
                :topshow="true"
                titletop="Runyu Apartment Quality Service"
                title="长春市人才公寓概况"
                styletop="f-18 c-99 m-b-15 d-flex-center"
                stylebot="d-flex-center f-30 c-00"
                all="m-t-50"
              >
              </title-box>
              <div class="d-flex-center">
                <div
                  class="f-18 c-00 width-90 lh-40 m-t-50"
                  v-html="newother.about_main.maincontent"
                ></div>
              </div>
              <div class="m-t-40 m-b-70 d-flex-center">
                <div class="f-30 c-99">
                  更多概况
                  <i class="el-icon-right f-30 c-99"></i>
                </div>
              </div>
            </div>
            <div class="m-r-20 d-flex-center">
              <video
                id="video"
                :src="newother.about_main.video_file"
                controls="true"
                poster="../../assets/image/index/vi.png"
                preload="auto"
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x5-video-orientation="portraint"
                style="object-fit: fill"
                class="width-90 h-250 shadow1"
              ></video>
            </div>
          </div>
        </div>
        <div class="d-flex-center hidden-xs-only">
          <div class="width-80 d-flex-row h-600 m-b-100">
            <div
              v-for="(item, index) in newother.about_list"
              :key="index"
              @mouseenter="mouseenter(index)"
              @mouseleave="mouseleave(index)"
              class="width-33 h-600"
            >
              <!--:style="{background:'url('+item.smallimages+')'}" style="background-size: 100% 100%;background-repeat: no-repeat;" -->
              <div class="width-100 h-600">
                <img :src="item.smallimages" class="width-100 h-600" />
              </div>
              <div style="margin-top: -600px" class="w-100p">
                <div
                  :class="mnav != index ? 'h-600' : 'h-300'"
                  class="d-flex-center d-flex-items-center w-100p"
                >
                  <div class="width-100">
                    <div class="d-flex-center width-100">
                      <img :src="item.image_icon" class="w-50 h-50" />
                    </div>
                    <div
                      class="d-flex-center width-100 f-20 c-white m-t-45 p-l-20 p-r-20"
                    >
                      {{ item.title }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="mnav == index"
                  v-html="item.maincontent"
                  style="position: absolute; width: 26.4%"
                  class="h-300 bgc-E94638-1 p-45 c-white f-20 lh-30 d-flex-center d-flex-items-center"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex-center hidden-sm-and-up"
          style="overflow-x: scroll; overflow: hidden"
        >
          <div class="d-flex-row h-350 m-b-70 m-l-20" style="overflow: auto">
            <div
              v-for="(item, index) in newother.about_list"
              :key="index"
              @mouseenter="mouseenter(index)"
              @mouseleave="mouseleave(index)"
              :style="{ background: 'url(' + item.smallimages + ')' }"
              style="background-size: 100% 350px"
              class="w-250 m-r-20"
            >
              <div
                :class="mnav != index ? 'h-350' : 'h-175'"
                class="w-250 d-flex-center d-flex-items-center"
              >
                <div>
                  <div class="d-flex-center width-100">
                    <img :src="item.image_icon" class="w-50 h-50" />
                  </div>
                  <div
                    class="d-flex-center width-100 f-20 c-white m-t-45 p-l-20 p-r-20"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div
                v-if="mnav == index"
                v-html="item.maincontent"
                class="h-180 bgc-E94638-1 p-45 c-white f-12 lh-20 d-flex-center d-flex-items-center"
              ></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import titleBox from "../../components/title.vue";
import {
  list,
  store,
  essence,
  listData,
  listthress,
  survey,
  imglist,
} from "./config/index.js";
export default {
  components: {
    titleBox,
  },
  data() {
    return {
      listthress: listthress,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
      ],
      value: "",
      search: "",
      selected: ["人才公寓", "专家公寓", "租赁房屋"],
      nav: 0,
      mnav: -1,
      imgnav: -1,
      classOption: {
        step: 0.2,
        limitMoveNum: 5,
        direction: 2,
      },
      classOption1: {
        limitMoveNum: 3,
        direction: 2,
      },
      info: {
        base_info: {},
      },
      newinfo: {},
      newother: {},
    };
  },
  mounted() {
    this.getinfo();
    this.getnews();
    this.getother();
    this.$nextTick(() => {
      new this.$wow.WOW().init();
    });
  },
  computed: {
    defaultOption() {
      return {
        step: 0.6,
        hoverStop: true,
        direction: 1,
      };
    },
  },
  methods: {
    gogo(community_id) {
      this.$router.push({
        path: "/room-details",
        query: {
          community_id: community_id,
        },
      });
    },
    go() {
      this.$router.push("/housing");
    },
    async getother() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const res = await this.$service.get({
        url: "/api/web/v1/app_get_index_other",
      });

      if (res.code === 1) {
        this.newother = res.info;
        this.$nextTick(() => {
          loading.close();
        }, 2000);
      }
    },
    async getnews() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const res = await this.$service.get({
        url: "/api/web/v1/app_get_index_news",
      });
      if (res.code === 1) {
        this.newinfo = res.info;
        this.$nextTick(() => {
          loading.close();
        }, 2000);
      }
    },
    async getinfo() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const res = await this.$service.get({
        url: "/api/web/v1/app_get_index",
      });
      if (res.code === 1) {
        this.info = res.info;
        this.$nextTick(() => {
          loading.close();
        }, 2000);
      }
    },
    liston(e) {
      // let target = e.target;
      // if (target.tagName === 'IMG') {
      // 	console.log('-----')
      // 	console.log(target.dataset.id)
      // }
    },
    handleClick(e) {
      let target = e.target;
      if (target.tagName === "SPAN") {
        console.log(target.dataset.id);
        this.$router.push({
          path: "/new-details",
          query: {
            news_id: target.dataset.id,
          },
        });
      }
    },
    imgbtn(e) {
      let target = e.target;
      if (target.tagName === "IMG") {
        this.imgnav = target.dataset.id;
      }
    },
    select(house_id) {
      this.$router.push({
        path: "/introduce",
        query: {
          house_id: house_id,
        },
      });
    },
    mouseover(index) {
      this.nav = index;
    },
    mouseenter(index) {
      this.mnav = index;
    },
    mouseleave(index) {
      this.mnav = -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.seamless-warp {
  height: 229px;
  overflow: hidden;
}

.fu1 {
  position: relative;
  top: 28%;
  z-index: 2;
}

.fu {
  position: relative;
  top: 20%;
  z-index: 2;
}

.c-D8D8D8 {
  color: #d8d8d8;
}

.bgc-f4f4f4 {
  background: #f4f4f4;
}

.c-EC4738 {
  color: #ec4738;
}

.bgc-EC4738 {
  background: #ec4738;
}

.bgimg {
  background: url("../../assets/image/index/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.bgc1 {
  background: rgba(0, 0, 0, 0.47);
  /* width: 46.7%; */
}

.bgc-DF4D40 {
  background: rgba(223, 77, 64, 0.85);
}

.bgc-000000 {
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(0, 0, 0, 0.25) 100%
  );
}

.shadow {
  box-shadow: 47px 47px 0px #e34f41;
}

.shadow1 {
  box-shadow: 20px 20px 0px #e34f41;
}

.bgc-E94638-1 {
  background: rgba(223, 70, 56, 0.9) !important;
}

.warp {
  width: 90px * 6;
  height: 90px;
  overflow: hidden;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    &.ul-item {
      display: flex;

      .li-item {
        // text-align: center;
      }
    }
  }
}

ul {
  list-style: none;
}

button {
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background: none !important;
}

.c-174a80 {
  color: #174a80;
}
</style>
